export default "__VITE_ASSET__4fdd4c52__"